var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm5.084-28.167a.414.414 0 01.307.142c.079.086.117.2.108.317l-.349 3.333a.416.416 0 01-.414.375h-2.777v9.583c0 .23-.185.417-.414.417h-4.144a.416.416 0 01-.415-.417V24h-2.072a.416.416 0 01-.414-.417V20.25c0-.23.186-.417.414-.417h2.072v-1.375c0-1.041.307-4.458 4.285-4.458h3.59c.228 0 .414.187.414.417v3.333a.418.418 0 01-.116.283.362.362 0 01-.29.125h-2.487c-.373 0-.423.267-.423.5v1.175h3.125z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Facebook;

Facebook.default = Facebook;
